import { authAxios } from '@components/Auth';
import humps from 'lodash-humps-ts';
import { InsurancePolicyItemList } from '@models/InsurancePolicyItem';
import { API_V1_BASE } from '@config';

export class InsurancePolicyItemApi {
  static getAll = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/user/insurance_policy_items`)
      .then((response) => humps(response.data) as InsurancePolicyItemList[]);
  };
}
